module.exports = __webpack_public_path__ + "static/media/23.45a09ab7.jpg";